module.exports = "/_next/static/images/cce987ff4527f5892ac2bee59122ca76-woman-playing-with-her-kids@lg.jpg";